export const FONT_SIZE = 16;
export const LINE_HEIGHT = 24;
export const MAX_WIDTH = 400;

export const SAMPLE_TEXTS = [
  'Hello, world!',
  'This is a short sentence.',
  'AGI 春天到了。人工智能正在改变世界，每天都有新的突破。这是一个令人兴奋的时代。',
  'بدأت الرحلة 🚀 The journey has begun. This text mixes Arabic, English and emoji in one string.',
  'A much longer paragraph to test line wrapping behavior. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
  '🌍🌎🌏 Emojis everywhere! 😂🔥💯 Testing how emoji clusters are handled across line breaks. Each emoji may be multiple code points but should count as one visual unit. 🎉',
  '日本語のテスト: このテキストは日本語で書かれており、正しく折り返されるかどうかを確認します。テキストの測定は重要です。',
  'Thisisaverylongwordwithoutspaces that should trigger overflow handling and potentially force a line break mid-word depending on the implementation.',
  '한국어 테스트: 이 텍스트는 한국어로 작성되었으며, 올바르게 줄 바꿈이 되는지 확인합니다.',
  'Short.',
  'Two\nlines\nhard breaks.',
  'Mixed script: English мир 中文 العربية한국어 日本語 all in one line to push boundaries.',
  'Performance test: rendering many items in a virtual list requires knowing exact heights before render. pretext solves this by providing accurate off-DOM height estimation with zero layout thrash.',
  'Café au lait, naïve résumé, über cool: accented characters and ligatures should measure correctly.',
  '   Leading and trailing spaces   and	tabs	should be handled consistently across implementations.',
];
